import Button from '@creator/ui/components/Button/ButtonV2';
import Text from '@creator/ui/components/Text/Text';
import Link from '@src/basic-components/Link/Link';
import type { FC } from 'react';
import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

interface ForumPickerButtonProps {
    className?: string;
}

const ForumPickerButton: FC<ForumPickerButtonProps> = props => {
    const { className } = props;
    const { t } = useTranslation();

    return (
        <Button className={className} size="sm" variant="ghost" color="base">
            <Text className="font-medium text-gray-50">{<Link to="/bbs/picker">{t('tokenPageHeader.forumPicker')}</Link>}</Text>
        </Button>
    );
};

export default memo(ForumPickerButton);
